const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";
const GA4_ID = process.env.REACT_APP_GA4_ID || "";
const GOOGLE_ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID || "";
const GOOGLE_ADS_LEAD_LABEL = process.env.REACT_APP_GOOGLE_ADS_LEAD_LABEL || "";

export function waLink() {
  const n = process.env.REACT_APP_WHATSAPP_NUMBER || "393522461148";
  return `https://wa.me/${n}?text=${encodeURIComponent("Ciao, vorrei informazioni su TRANS RAT per la mia attività.")}`;
}

export function trackContact(source) {
  track("contact", { source });
}

export const STEP_NAMES = { 1: "Inizia", 2: "Chi siamo", 3: "Le referenze", 4: "Il video", 5: "La soluzione", 6: "La vostra struttura", 7: "Parliamone" };

const EVENT_MAP = {
  pageview: "PageView",
  view_content: "ViewContent",
  funnel_step_view: "FunnelStepView",
  funnel_next: "FunnelNext",
  funnel_back: "FunnelBack",
  contact_form_start: "ContactFormStart",
  contact: "Contact",
  lead: "Lead",
};

export function envMode() {
  if (sessionStorage.getItem("sf_env")) return sessionStorage.getItem("sf_env");
  const isTest = new URLSearchParams(window.location.search).has("test");
  sessionStorage.setItem("sf_env", isTest ? "test" : "production");
  return isTest ? "test" : "production";
}

export function getConsent() {
  try {
    return localStorage.getItem("sf_consent") || "";
  } catch (e) {
    return "";
  }
}

export function setConsent(value) {
  try {
    localStorage.setItem("sf_consent", value);
  } catch (e) {}
  window.dispatchEvent(new Event("sf-consent-change"));
}

function sessionId() {
  let sid = sessionStorage.getItem("sf_sid");
  if (!sid) {
    sid = crypto.randomUUID ? crypto.randomUUID() : `s-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem("sf_sid", sid);
  }
  return sid;
}

function collectUtm() {
  const KEY = "sf_utm_first";
  let stored = null;
  try {
    stored = JSON.parse(localStorage.getItem(KEY) || "null");
  } catch (e) {
    stored = null;
  }
  if (!stored) {
    const p = new URLSearchParams(window.location.search);
    stored = {
      utm_source: p.get("utm_source") || "",
      utm_medium: p.get("utm_medium") || "",
      utm_campaign: p.get("utm_campaign") || "",
      utm_content: p.get("utm_content") || "",
      utm_term: p.get("utm_term") || "",
      fbclid: p.get("fbclid") || "",
      gclid: p.get("gclid") || "",
      landing_url: window.location.href,
      referrer: document.referrer || "",
    };
    try {
      localStorage.setItem(KEY, JSON.stringify(stored));
    } catch (e) {}
  }
  return stored;
}

export function getUtm() {
  return collectUtm();
}

export function currentStep() {
  const m = window.location.pathname.match(/funnel\/([a-z-]+)/);
  if (!m) return window.location.pathname.endsWith("/funnel") ? 1 : null;
  const order = ["chi-siamo", "referenze", "come-funziona", "soluzione", "azienda", "contatto"];
  return order.indexOf(m[1]) + 2;
}

export function track(event, extra = {}) {
  try {
    if (getConsent() !== "all") return;
    const { step, fb_params, ...rest } = extra;
    const payload = {
      session_id: sessionId(),
      event,
      step: step !== undefined ? step : currentStep(),
      environment: envMode(),
      page_url: window.location.href,
      referrer: document.referrer || "",
      utm: collectUtm(),
      ...rest,
    };
    if (META_PIXEL_ID && window.fbq) {
      try {
        // Eventi personalizzati del funnel con trackCustom (raccomandazione Meta); il Lead
        // ha un blocco dedicato (parametri non personali + eventID = codice pratica): la
        // mappa generica non deve ripeterlo.
        const META_STANDARD = new Set(["PageView", "ViewContent", "Lead"]);
        const metaName = EVENT_MAP[event] || event;
        if (event !== "lead") {
          if (META_STANDARD.has(metaName)) window.fbq("track", metaName, fb_params || {});
          else window.fbq("trackCustom", metaName, fb_params || {});
        }
        // ViewContent: una sola volta per sessione, al primo contenuto del funnel visualizzato
        if (event === "funnel_step_view" && !sessionStorage.getItem("sf_vc_fired")) {
          sessionStorage.setItem("sf_vc_fired", "1");
          window.fbq("track", "ViewContent", { content_name: "TRANS RAT — landing" });
        }
        // Lead: solo parametri non personali. event_id = codice pratica (deduplica Pixel + CAPI)
        if (event === "lead") {
          const leadParams = { lead_source: "transrat_landing", product: "trans_rat", funnel: "transrat_b2b" };
          if (rest.code) window.fbq("track", "Lead", leadParams, { eventID: rest.code });
          else window.fbq("track", "Lead", leadParams);
        }
      } catch (e) {}
    }
    if (GA4_ID && window.gtag) {
      try {
        if (event === "funnel_step_view") window.gtag("event", "view_content", { step_name: STEP_NAMES[payload.step] || String(payload.step) });
        if (event === "contact_form_start") window.gtag("event", "begin_checkout", { step_name: STEP_NAMES[payload.step] || "Parliamone" });
        if (event === "lead") window.gtag("event", "generate_lead", { lead_source: "transrat_landing", product: "trans_rat", funnel: "transrat_b2b", lead_code: rest.code || "" });
      } catch (e) {}
    }
    if (GOOGLE_ADS_ID && event === "lead" && window.gtag && GOOGLE_ADS_LEAD_LABEL) {
      try {
        window.gtag("event", "conversion", { send_to: `${GOOGLE_ADS_ID}/${GOOGLE_ADS_LEAD_LABEL}` });
      } catch (e) {}
    }
    fetch(`${API}/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {}
}

export function trackLeadOnce(extra = {}) {
  if (sessionStorage.getItem("sf_lead_fired")) return;
  sessionStorage.setItem("sf_lead_fired", "1");
  track("lead", extra);
}

export function initPixels() {
  if (getConsent() !== "all") return;
  const GA4_ID = process.env.REACT_APP_GA4_ID || "";
  if (META_PIXEL_ID && !window.fbq) {
    const n = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    const s = document.createElement("script");
    s.async = true;
    s.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(s);
    window.fbq("init", META_PIXEL_ID);
    window.fbq("track", "PageView");
  }
  if (GA4_ID && !window.gtag) {
    const s4 = document.createElement("script");
    s4.async = true;
    s4.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(s4);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GA4_ID);
  }
  if (GOOGLE_ADS_ID && !window.gtag) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GOOGLE_ADS_ID);
  }
}
